import { render, staticRenderFns } from "./Volunteer.vue?vue&type=template&id=47d07a68"
import script from "./Volunteer.vue?vue&type=script&lang=js"
export * from "./Volunteer.vue?vue&type=script&lang=js"
import style0 from "./Volunteer.vue?vue&type=style&index=0&id=47d07a68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports